import { createSelector } from 'reselect'
import {
  selectCurrentCELs as selectCurrentCELLoans,
  selectHighestRateLoan,
  getConsolidatedBulkPaymentOnLoan
} from './loans'
import mapValues from 'lodash/mapValues'
import { Dictionary } from 'finance'

const getHomeData = state => state.home.data

const dictionary = new Dictionary()

const mergeLoans = fn => state => ({
  ...getHomeData(state),
  loans: fn(state)
})

export const bindDictionary = home =>
  mapValues(dictionary, f => (...args) => {
    if (home) return f.call(dictionary, home, ...args)
    return undefined
  })

export const selectCurrentCELs = createSelector(
  mergeLoans(selectCurrentCELLoans),
  bindDictionary
)

export const selectFromCurrentCELs = attr => state =>
  selectCurrentCELs(state)[attr]()

export const selectAll = createSelector(
  getHomeData,
  bindDictionary
)

export const selectFromAll = attr => state => selectAll(state)[attr]()

export const selectHighestRateLoanDictionary = createSelector(
  mergeLoans(state => [selectHighestRateLoan(state)]),
  bindDictionary
)

export const selectExtraPaymentSavingsCalculator = createSelector(
  selectCurrentCELs,
  dictionary => {
    return amt =>
      dictionary.loans().reduce(
        (sum, loan) =>
          (sum +=
            dictionary.extraPaymentSavingsTotal({
              amt,
              diff: [getConsolidatedBulkPaymentOnLoan(loan)]
            }) || 0),
        0
      )
  }
)

export const selectExtraPaymentSavedYearsCalculator = createSelector(
  selectCurrentCELs,
  dictionary => {
    return amt =>
      dictionary.loans().reduce(
        (sum, loan) =>
          (sum +=
            dictionary.extraPaymentYears({
              amt,
              diff: [getConsolidatedBulkPaymentOnLoan(loan)]
            }) || 0),
        0
      )
  }
)

export const selectAvmWithoutCMA = createSelector(
  getHomeData,
  home => (home ? dictionary.avmObjectWithoutCMA(home) : undefined)
)

export const sortMostRecentAVMs = avms => dictionary.sortMostRecentAVMs(avms)
